<template>
  <div></div>
</template>

<script>
export default {
  name: 'Home',
  created () {
    window.location.href = 'https://lp.gamega.me/lp/app/gg/ba_psms_msisdn.html'
  },
  mounted () {
    window.location.href = 'https://lp.gamega.me/lp/app/gg/ba_psms_msisdn.html'
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/BA/LP.vue